// extracted by mini-css-extract-plugin
module.exports = {"videoFooter":"video-control_videoFooter__29Kw_","btn":"video-control_btn__puHwl"};